module.exports = __webpack_public_path__ + "img/room.f3b54c6c.svg";